var map = {
	"./_base/images/branding-logo.svg": 214,
	"./aisTh/images/branding-logo.svg": 215,
	"./bnpParibasFR/images/branding-logo.svg": 216,
	"./bolttech/images/branding-logo.svg": 217,
	"./fwdGI/images/branding-logo.svg": 218,
	"./fwdLIFE/images/branding-logo.svg": 219,
	"./homecreditPh/images/branding-logo.svg": 220,
	"./hyundaiCard/images/branding-logo.svg": 221,
	"./lguplus/images/branding-logo.svg": 222,
	"./linefrank/images/branding-logo.svg": 223,
	"./orangeFR/images/branding-logo.svg": 224,
	"./paymayaPh/images/branding-logo.svg": 225,
	"./reconnects/images/branding-logo.svg": 226,
	"./threeIe/images/branding-logo.svg": 227,
	"./threehk/images/branding-logo.svg": 228,
	"./wind/images/branding-logo.svg": 229,
	"./windtreIT/images/branding-logo.svg": 230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 213;